import { Box, useTheme } from "@seneca/senekit";

export default function NotificationDot() {
  const theme = useTheme();

  return (
    <Box
      width="10px"
      height="10px"
      borderRadius="medium"
      backgroundColor={theme["primary-high-surface"]}
    />
  );
}
